import { FC } from 'react'

import { Text } from '@revolut-internal/ui-kit'

import { BreachCell } from 'components/TableCells/BreachCell'
import { TimeMetric } from 'types'
import { formatDuration } from 'utils/formatTimeAndDuration'

type DurationCellProps = {
  metric: TimeMetric | null
}

export const DurationCell: FC<DurationCellProps> = ({ metric }) => {
  if (!metric) {
    return <Text color="grey-tone-20">-</Text>
  }

  const slaBreachValue = metric.slaBreachValue
    ? formatDuration(metric.slaBreachValue)
    : undefined

  return (
    <BreachCell slaBreach={metric.slaBreach} slaBreachValue={slaBreachValue}>
      {formatDuration(metric.value)}
    </BreachCell>
  )
}
